/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHClosedIcon20Solid = forwardRef('ArrowCollapseCHClosedIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.123 11.944a2.75 2.75 0 0 0 0-3.889l-3.24-3.24a1.25 1.25 0 0 0-1.767 1.769l3.24 3.239a.25.25 0 0 1 0 .354l-3.24 3.239a1.25 1.25 0 0 0 1.768 1.768l3.24-3.24Z" }),
        React.createElement("path", { d: "M11.877 11.944a2.75 2.75 0 0 1 0-3.889l3.24-3.24a1.25 1.25 0 0 1 1.767 1.769l-3.24 3.239a.25.25 0 0 0 0 .354l3.24 3.239a1.25 1.25 0 0 1-1.768 1.768l-3.24-3.24Z" })));
});
